import { tokens } from "../tokens";

export const en = {
	[tokens.common.languageChanged]: "Language changed",
};
